// Date utilities — the pickup day is stored as an ISO date string ("2026-10-12")
// these build/parse/format it. All work uses Date objects (no regex).

window.DateUtils = {
  // Date → "2026-10-12" (local calendar date, not UTC).
  dateToIso(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  },

  // "2026-10-12" → Date (midnight local). A non-ISO string yields an invalid Date.
  isoToDate(iso) {
    const [year, month, day] = String(iso).split('-').map(Number);
    return new Date(year, month - 1, day);
  },

  // "2026-10-12" → "Sunday, October 12". Returns the input unchanged if it isn't a valid date.
  formatLong(iso) {
    const date = window.DateUtils.isoToDate(iso);
    if (isNaN(date.getTime())) return iso;
    return date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
  },

  // Gets suffix for displaying dates (Example: 11 returns "th", 22 returns "nd")
  ordinalSuffix(dayNumber) {
    if (dayNumber % 100 >= 11 && dayNumber % 100 <= 13) return 'th';
    switch (dayNumber % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  },

  // "2026-10-12" → "Oct 12th". Returns the input unchanged if it isn't a valid date.
  formatMonthDay(iso) {
    const date = window.DateUtils.isoToDate(iso);
    if (isNaN(date.getTime())) return iso;
    const dayNumber = date.getDate();
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    return `${month} ${dayNumber}${window.DateUtils.ordinalSuffix(dayNumber)}`;
  },

  // "2026-10-12" → "Sun, Oct 12th". Returns the input unchanged if it isn't a valid date.
  formatWeekdayMonthDay(iso) {
    const date = window.DateUtils.isoToDate(iso);
    if (isNaN(date.getTime())) return iso;
    const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
    return `${weekday}, ${window.DateUtils.formatMonthDay(iso)}`;
  },
};
